import { Text, Dialog, Headline } from "./";
import type { SharedFormatMessage } from "@akina/infra";

export const UseOnLargerScreenModal = ({ formatMessage }: { formatMessage: SharedFormatMessage }) => (
  <Dialog className="max-w-[80%]" open={true} withClose={false}>
    <Headline size="2xl">{formatMessage({ id: "shared.dialogs.useOnDesktopDialog.title" })}</Headline>
    <Text className="mt-12">{formatMessage({ id: "shared.dialogs.useOnDesktopDialog.subtitle" })}</Text>
  </Dialog>
);
